import { COLOUR } from "../../config/constants";

const PILL_CLASSES = {
  [COLOUR.GREEN]: "text-accent-700 bg-signal-green-50 ring-1 ring-signal-green-100 ring-inset",
  [COLOUR.GRAY]: "text-ink-700 bg-cream-200 ring-1 ring-ink-200 ring-inset",
  [COLOUR.YELLOW]: "text-signal-amber-600 bg-signal-amber-50 ring-1 ring-signal-amber-100 ring-inset",
  [COLOUR.BLUE]: "text-accent-700 bg-accent-100 ring-1 ring-accent-200 ring-inset",
  [COLOUR.RED]: "text-signal-red-700 bg-signal-red-50 ring-1 ring-signal-red-100 ring-inset",
};

const DOT_CLASSES = {
  [COLOUR.GREEN]: "bg-signal-green-500",
  [COLOUR.GRAY]: "bg-ink-400",
  [COLOUR.YELLOW]: "bg-signal-amber-500",
  [COLOUR.BLUE]: "bg-accent-500",
  [COLOUR.RED]: "bg-signal-red-500",
};

const StatusIndicator = ({
  colour,
  label,
  variant = "pill",
  hideWhenConfirmed = false,
}) => {
  if (hideWhenConfirmed && colour === COLOUR.BLUE) {
    return null;
  }

  if (variant === "dot") {
    const dotColour = DOT_CLASSES[colour] || "bg-ink-400";
    return (
      <span className="inline-flex items-center gap-x-1.5 text-xs text-ink-600">
        <span
          aria-hidden="true"
          className={`${dotColour} size-1.5 shrink-0 rounded-full`}
        />
        {label}
      </span>
    );
  }

  const pillColour = PILL_CLASSES[colour] || "";
  const dotColour = DOT_CLASSES[colour] || "bg-ink-400";
  return (
    <span
      className={`${pillColour} inline-flex items-center gap-x-1.5 rounded-pill px-2 py-0.5 text-xs/5 font-medium`}
    >
      <span aria-hidden="true" className={`${dotColour} size-1.5 rounded-full`} />
      {label}
    </span>
  );
};

export default StatusIndicator;
